import { createContext } from 'react';

const ColorToolsContext = createContext();

export default ColorToolsContext;
